import React from 'react'
import MainRoutes from '../routes/MainRoutes'

const App = () => {
  return (
    <>
      <MainRoutes />
    </>
  )
}

export default App